module.exports = __webpack_public_path__ + "img/17.176966d2.png";